

export const COMPANIES = ["CMPAS","COMPASS"]
export const ADANI = ["AWLUAT","AWL"]
export const BAJAJ = ["BAJAJELECT",'bajajelec']